import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import blogData from "../data/blogData.json";

const Blog = () => {
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState(1);
    const postsPerPage = 3;

    // Calculate current posts and total pages
    const indexOfLastPost = activePage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = blogData.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(blogData.length / postsPerPage);

    const handleReadMore = (slug) => {
        navigate(`/blog/${slug}`);
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="dbs-blog">
            <Helmet>
                <title>DBS EMI Blog | Financial Insights & Education</title>
                <meta name="description" content="Educational content and insights about DBS EMI plans, financial management, and smart payment solutions." />
                <meta name="keywords" content="DBS EMI, Equated Monthly Installments, Singapore banking, financial planning, loan management" />
            </Helmet>

            <NavBar />

            {/* Blog Content Section */}
            <section className="py-5 bg-light">
                <Container>
                    <div className="text-center mb-5">
                        <h2 className="h4 text-uppercase text-primary mb-3">Educational Resources</h2>
                        <h3 className="display-5 fw-bold mb-3">Latest Insights on DBS EMI</h3>
                        <p className="text-muted lead mx-auto" style={{ maxWidth: '700px' }}>
                            Discover how to make the most of your DBS EMI options with our comprehensive guides
                        </p>
                    </div>

                    <Row className="g-4 mb-5">
                        {currentPosts.map((post) => (
                            <Col key={post.id} lg={4} md={6}>
                                <Card className="h-100 shadow-sm border-0 overflow-hidden transition-all hover-lift">
                                    <div className="position-relative" style={{ paddingTop: '56.25%' }}>
                                        <Card.Img
                                            variant="top"
                                            src={post.image}
                                            alt={post.title}
                                            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                    <Card.Body>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="badge bg-primary bg-opacity-10 text-primary">{post.category}</span>
                                            <small className="text-muted">{post.date}</small>
                                        </div>
                                        <Card.Title className="mb-3">
                                            <a
                                                href={`/blog/${post.slug}`}
                                                className="text-dark text-decoration-none stretched-link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleReadMore(post.slug);
                                                }}
                                            >
                                                {post.title}
                                            </a>
                                        </Card.Title>
                                        <Card.Text className="text-secondary mb-3">{post.excerpt}</Card.Text>
                                        <Button
                                            variant="link"
                                            className="px-0 text-primary text-decoration-none d-flex align-items-center"
                                            onClick={() => handleReadMore(post.slug)}
                                        >
                                            Read More <i className="bi bi-arrow-right ms-2"></i>
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-center mt-5">
                            <ul className="pagination-custom list-unstyled d-flex gap-2">
                                <li>
                                    <Button
                                        variant="outline-secondary"
                                        className="rounded-pill px-3 py-1"
                                        disabled={activePage === 1}
                                        onClick={() => handlePageChange(activePage - 1)}
                                    >
                                        &laquo;
                                    </Button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                    <li key={i + 1}>
                                        <Button
                                            variant={activePage === i + 1 ? 'primary' : 'outline-primary'}
                                            className={`rounded-pill px-3 py-1 fw-semibold ${activePage === i + 1 ? 'text-white' : ''}`}
                                            onClick={() => handlePageChange(i + 1)}
                                        >
                                            {i + 1}
                                        </Button>
                                    </li>
                                ))}
                                <li>
                                    <Button
                                        variant="outline-secondary"
                                        className="rounded-pill px-3 py-1"
                                        disabled={activePage === totalPages}
                                        onClick={() => handlePageChange(activePage + 1)}
                                    >
                                        &raquo;
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    )}
                </Container>
            </section>
            <Footer />
        </div>
    );
};

export default Blog;